<template>
  <v-container fluid class="my-club-events pa-3 pa-md-6">
    <div class="d-flex align-center mb-6">
      <v-avatar color="primary" size="48" class="mr-4 elevation-2">
        <v-icon dark>mdi-calendar-star</v-icon>
      </v-avatar>
      <div>
        <h1 class="text-h5 text-md-h4 font-weight-bold mb-1">{{ $t('ce_my_title') }}</h1>
        <p class="grey--text text--darken-1 mb-0">{{ $t('ce_my_description') }}</p>
      </div>
    </div>

    <v-alert v-if="errorMessage" type="error" outlined>{{ errorMessage }}</v-alert>
    <v-progress-linear v-if="loading" indeterminate />
    <v-alert v-else-if="!events.length && !errorMessage" type="info" outlined>{{ $t('ce_empty') }}</v-alert>

    <v-row>
      <v-col v-for="e in events" :key="e.id" cols="12" md="6">
        <v-card outlined>
          <v-card-title class="d-flex justify-space-between">
            <span>{{ e.name }}</span>
            <v-chip v-if="e.canceled" small color="red" dark>{{ $t('ce_canceled') }}</v-chip>
          </v-card-title>
          <v-card-text>
            <div>{{ e.date }} · {{ e.time }} · {{ e.location }}</div>
            <div v-if="e.notes">{{ e.notes }}</div>
            <div v-if="e.payment_status !== 'not_applicable'" class="mt-2">
              {{ $t('ce_payment') }}: ${{ Number(e.price).toFixed(2) }}
              <v-chip small :color="e.payment_status === 'paid' ? 'green' : 'orange'" dark class="ml-2">
                {{ $t(e.payment_status === 'paid' ? 'ce_payment_paid' : 'ce_payment_pending') }}
              </v-chip>
            </div>
            <div class="mt-3 font-weight-bold">{{ $t('ce_guests') }} ({{ e.guests_inside }} / {{ e.guests_total }})</div>
            <v-chip v-for="g in e.guests" :key="g.id" small class="mr-1 mt-1" :color="g.status === 0 ? '' : 'green lighten-4'">
              {{ g.full_name }}
            </v-chip>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getMyClubEvents } from '@/services/clubEvents'

export default {
  name: 'MyClubEvents',
  data: () => ({ events: [], loading: false, errorMessage: '' }),
  async created () {
    this.loading = true
    try {
      this.events = (await getMyClubEvents()).data
    } catch (error) {
      this.errorMessage = this.$t('ce_error')
    } finally {
      this.loading = false
    }
  }
}
</script>
